import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=12bf4f1d&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf4f1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12bf4f1d')) {
      api.createRecord('12bf4f1d', component.options)
    } else {
      api.reload('12bf4f1d', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=12bf4f1d&scoped=true&", function () {
      api.rerender('12bf4f1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZIOBywhHO3an/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports